var map = {
	"./Channel": 46611,
	"./Channel.js": 46611,
	"./ComingSoon": 85866,
	"./ComingSoon.js": 85866,
	"./Home": 88656,
	"./Home.js": 88656,
	"./Latest": 44077,
	"./Latest.js": 44077,
	"./Playlist": 12720,
	"./Playlist.js": 12720,
	"./Search": 83661,
	"./Search.js": 83661,
	"./UserWatch": 23352,
	"./UserWatch.js": 23352,
	"./Watch": 16843,
	"./Watch.js": 16843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91434;